module.exports = __webpack_public_path__ + "static/img/document_hover.32e09fa7.svg";